const Sizzle = require('sizzle');

import * as domUtils from '../../util/dom';
import AudioTrack from '../../constants/audio-track';


const NAMESPACE = 'ui-language-dialog';
const CAPTIONS_STORAGE_KEY = "captionsOn";

const CLASSNAMES = {
    textTrackLabel: 'svp_js-controls__text-track-label-text'
};

export default class LanguageDialog {
    constructor(api, languageButton) {
        this.api = api;
        this.languageButton = languageButton;
    }

    static _getSpokenTextTrack(audioTracks) {
        for (let i = 0; i < audioTracks.length; i++) {
            if (audioTracks[i].id === AudioTrack.SPOKEN_TEXT) {
                return audioTracks[i];
            }
        }

        return undefined;
    }

    _createElement() {
        const form = domUtils.fromString('<form class="svp_ui-controls__language-dialog"></form>');
        const audioTracks = this.api.getAudioTracks();
        const textTracks = this.api.getTextTracks();
        const spokenTextTrack = LanguageDialog._getSpokenTextTrack(audioTracks);

        if (spokenTextTrack) {
            const audioTrackSettings = domUtils.fromString(
                `<fieldset class="svp_ui-controls__language-dialog-content">
                    <legend class="svp_ui-controls__language-dialog-title">Tillval</legend>
                    <label class="svp_ui-controls__label svp_ui-controls__language-dialog-label">
                        Av
                        <input name="audio_track" type="radio" value="off" ${!spokenTextTrack.active ? 'checked' : ''} class="svp_ui-controls__language-dialog-checkbox">
                        <span class="svp_ui-controls__language-dialog-checkmark"></span>
                    </label>
                    <label class="svp_ui-controls__label svp_ui-controls__language-dialog-label">
                        Uppläst text
                        <input name="audio_track" type="radio" value="spoken_text_on" ${spokenTextTrack.active ? 'checked' : ''} class="svp_ui-controls__language-dialog-checkbox">
                        <span class="svp_ui-controls__language-dialog-checkmark"></span>
                    </label>
                </fieldset>`);
            form.appendChild(audioTrackSettings);
        }

        if (textTracks.length > 0) {
            const textTrackActive = domUtils.getStoredData(CAPTIONS_STORAGE_KEY) === 'true';

            const textTrackSettings = domUtils.fromString(`<fieldset class="svp_ui-controls__language-dialog-content">
                    <legend class="svp_ui-controls__language-dialog-title">Undertext</legend>
                    <div class="svp_ui-controls__slider">
                        <label class="svp_ui-controls__label" tabindex="-1" for="svp_ui-controls__text_track_selector">
                            <span class="svp_visually-hidden">Visa undertext</span>
                            <span class="${CLASSNAMES.textTrackLabel}" aria-hidden="true">${textTrackActive ? 'På' : 'Av'}</span>
                            <input type="checkbox" value="None" id="svp_ui-controls__text_track_selector" name="text_track" ${textTrackActive ? 'checked' : ''} class="svp_ui-controls__slider-input"/>
                            <span class="svp_ui-controls__slider-background"><span class="svp_ui-controls__slider-dot"></span></span>
                        </label>
                    </div>
                </fieldset>`);
            form.appendChild(textTrackSettings);
        }

        const closeButton = domUtils.fromString('<button class="svp_ui-controls__language-dialog-close-button">Stäng</button>');

        domUtils.addEvents(closeButton, 'click', (e) => {
            e.stopPropagation();
            e.preventDefault();
            this.destroy();
        });

        const container = domUtils.fromString('<div class="svp_js-controls__language-dialog-container svp_ui-controls__language-dialog-container"></div>');

        container.appendChild(form);
        container.appendChild(closeButton);

        return container;
    }

    _handleTextTrackSelection(event) {
        const labels = Sizzle('.' + CLASSNAMES.textTrackLabel);

        if (event.target.checked) {
            this._showCaptions(true);

            labels.forEach((element) => {
                element.innerHTML = 'På';
            });
        } else {
            this._showCaptions(false);

            labels.forEach((element) => {
                element.innerHTML = 'Av';
            });
        }
    }

    _setAudioTrack(track) {
        this.api.setAudioTrack(track);
    }

    _showCaptions(shouldShow) {
        domUtils.setStoredData(CAPTIONS_STORAGE_KEY, shouldShow);
        this.api.showCaptions(shouldShow);
    }

    _handleHelpersSelection(event) {
        if (event.target.value === 'off' && event.target.checked) {
            this._setAudioTrack(AudioTrack.DEFAULT_AUDIO);
        } else if (event.target.value === 'spoken_text_on' && event.target.checked) {
            this._setAudioTrack(AudioTrack.SPOKEN_TEXT);
        }
    }

    _getElement(className) {
        return Sizzle('.' + className, this.api.element())[0];
    }

    _addChangeListeners() {
        Sizzle('input[name="text_track"]', this.element).forEach((element) => {
            domUtils.addEvents(element, 'change', (e) => {
                this._handleTextTrackSelection(e);
            }, NAMESPACE);

            domUtils.addEvents(element, 'keyup, keydown', (e) => {
                if (domUtils.getKeyFromKeyEvent(e) === 'space') {
                    e.stopPropagation();
                }
            }, NAMESPACE);
        });

        Sizzle('input[name="audio_track"]', this.element).forEach((element) => {
            domUtils.addEvents(element, 'change', (e) => {
                this._handleHelpersSelection(e);
            }, NAMESPACE);
        });

        Sizzle('input[name="audio_track"]', this.element).forEach((element) => {
            // empty
        });
    }

    _stopPropagation() {
        // Do not let clicks and mousedown (to prevent losing focus) propagate to player
        domUtils.addEvents(this.element, 'mousedown, click, touchend', (e) => {
            e.stopPropagation();
        }, NAMESPACE);

        domUtils.addEvents(this.element, 'focusin', (e) => {
            e.stopPropagation();
        }, NAMESPACE);
    }

    create() {
        this.element = this._createElement();
        this._stopPropagation();
        this._addChangeListeners();

        return this.element;
    }

    destroy() {
        this.languageButton.destroyDialog();
    }
}



// WEBPACK FOOTER //
// ./src/js/plugins/ui/language-dialog.js